module.exports = __webpack_public_path__ + "static/media/4.667659f3.webp";